import _ from "lodash";
import { ENGLISH, SPANISH } from "../../app.constants";
import {
    CREW_FILTER,
    DATE_ADDED_END_FILTER,
    DATE_ADDED_START_FILTER,
    DOCUMENT_STATUS_FILTER,
    WORKER_STATUS_FILTER,
} from "../common/common.filters";
import moment from "moment";

export function wrap_option(value) {
    if (!_.isNil(value)) {
        return {
            label: value,
            value: value,
        };
    }
}

export function removeNulls(data) {
    return _.pickBy(data, _.negate(_.isNull));
}

export function getFirstFieldWithErrorBase(form, erredControls) {
    let erredControlNames = _.compact(_.map(erredControls, "$name"));
    let orderedFields = _.filter(
        _.get(form, "$$element[0].elements", []),
        function (element) {
            return _.includes(erredControlNames, element.name);
        },
    );
    if (!_.isEmpty(orderedFields)) {
        return _.first(orderedFields);
    }

    let firstControlWithElement = _.find(erredControls, function (control) {
        return _.get(control, "$$element[0]");
    });
    return _.get(firstControlWithElement, "$$element[0]");
}

export const SORTS = {
    first_name: {
        label: "paperworkSorts.SORT_BY_FIRST_NAME",
        params: { order_by: "first_name" },
        func: function (element) {
            return _.toLower(_.get(element, "growerMembership.first_name", ""));
        },
        order: "asc",
    },
    last_name: {
        label: "paperworkSorts.SORT_BY_LAST_NAME",
        params: { order_by: "last_name" },
        func: function (element) {
            return _.toLower(_.get(element, "growerMembership.last_name", ""));
        },
        order: "asc",
    },
    date_added: {
        label: "paperworkSorts.SORT_BY_DATE_ADDED",
        params: { order_by: "date_added" },
        func: function (element) {
            return moment(element.growerMembership.date_added);
        },
        order: "desc",
    },
    employee_id: {
        label: "paperworkSorts.SORT_BY_EMPLOYEE_ID",
        params: { order_by: "employee_id" },
        func: function (element) {
            return element.growerMembership.employee_id;
        },
        order: "asc",
    },
};
export const FILTERS = {
    status: WORKER_STATUS_FILTER,
    document_status: DOCUMENT_STATUS_FILTER,
    date_added_start: DATE_ADDED_START_FILTER,
    date_added_end: DATE_ADDED_END_FILTER,
    crew: CREW_FILTER,
};
export const ONBOARDING_REPORT_FILTERS = {
    status: WORKER_STATUS_FILTER,
    document_status: DOCUMENT_STATUS_FILTER,
    date_added_start: DATE_ADDED_START_FILTER,
    date_added_end: DATE_ADDED_END_FILTER,
    crew: CREW_FILTER,
    document_packages: {
        func: function (element, test) {
            return true;
        },
    },
    calendar_year: {
        func: function (element, test) {
            return true;
        },
    },
};

export function getNextRole(documentPackageRequest, documentPackage) {
    let signingOrder = _.get(documentPackage, "signing_order", {});
    return _.invert(signingOrder)[
        documentPackageRequest.latest_signer_order + 1
    ];
}

export function getRemainingRoles(documentPackageRequest, documentPackage) {
    let signingOrder = _.get(documentPackage, "signing_order", {});
    return _.keys(
        _.pickBy(signingOrder, function (value, key) {
            return value > documentPackageRequest.latest_signer_order;
        }),
    );
}

export function getSchemaFromTranslation(preferredLanguage, translations) {
    let schema = {};
    let languagesToTry = [preferredLanguage, ENGLISH, SPANISH];
    for (let language of languagesToTry) {
        let translation = _.find(translations, { language });
        if (translation) {
            schema = translation.schema;
            break;
        }
    }
    return schema;
}
